import styled from 'styled-components';

export const SideBoxFooter = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;
